import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";
import { useConnectivity } from "@/hooks/use-connectivity";

const Navbar = () => {
  const [open, setOpen] = useState(false);
  const isOffline = useConnectivity();

  return (
    <nav className={`fixed left-0 right-0 z-50 glass shadow-soft transition-all duration-300 ${isOffline ? 'top-8' : 'top-0'}`}>
      <div className="container mx-auto flex items-center justify-between h-16 px-6">
        <a href="/" className="flex-shrink-0 flex items-center">
          <img 
            src="https://res.cloudinary.com/tatikka/image/upload/v1774976999/Logo_Simples_f4nl6q.svg" 
            alt="Tavares & Camilo" 
            className="h-10 w-auto"
          />
        </a>

        <div className="hidden md:flex items-center gap-8 font-body text-sm font-medium text-navy">
          <a href="#seguros" className="hover:text-primary transition-colors">Seguros</a>
          <a href="#consorcios" className="hover:text-primary transition-colors">Consórcios</a>
          <a href="#planos-de-saude" className="hover:text-primary transition-colors">Planos de Saúde</a>
          <a href="#planos-odontologicos" className="hover:text-primary transition-colors">Planos Odontológicos</a>
          <a href="#sobre" className="hover:text-primary transition-colors">Sobre</a>
          <a href="#faq" className="hover:text-primary transition-colors">FAQ</a>
          <a href="#contato" className="hover:text-primary transition-colors">Contato</a>
        </div>

        <a href="#contato" className="hidden md:inline-flex">
          <Button variant="hero" size="default">
            Fale Conosco
          </Button>
        </a>

        <button 
          onClick={() => setOpen(!open)} 
          className="md:hidden text-navy"
          aria-label={open ? "Fechar menu" : "Abrir menu"}
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-white border-t border-border px-6 pb-6 pt-2 space-y-3 animate-fade-up shadow-lg relative z-50">
          <a href="#seguros" className="block font-body text-navy py-2" onClick={() => setOpen(false)}>Seguros</a>
          <a href="#consorcios" className="block font-body text-navy py-2" onClick={() => setOpen(false)}>Consórcios</a>
          <a href="#planos-de-saude" className="block font-body text-navy py-2" onClick={() => setOpen(false)}>Planos de Saúde</a>
          <a href="#planos-odontologicos" className="block font-body text-navy py-2" onClick={() => setOpen(false)}>Planos Odontológicos</a>
          <a href="#sobre" className="block font-body text-navy py-2" onClick={() => setOpen(false)}>Sobre</a>
          <a href="#faq" className="block font-body text-navy py-2" onClick={() => setOpen(false)}>FAQ</a>
          <a href="#contato" className="block font-body text-navy py-2" onClick={() => setOpen(false)}>Contato</a>
          <a href="#contato" className="block w-full">
            <Button variant="hero" className="w-full" onClick={() => setOpen(false)}>Fale Conosco</Button>
          </a>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
